export default "__VITE_ASSET__CWDSl371__"